import {z} from 'zod';

// Upload surface the asset originated from. Informs Asset Studio filtering,
// analytics, and asset-lineage displays.
// - `cms` is set at read-time when mapping a dbFile document to an Asset;
//   it is not persisted on the `files` collection.
export const assetUploadSources = [
  'designer',
  'dashboard',
  'asset_studio',
  'public_api',
  'figma_import',
  'site_clone',
  'cms',
] as const;

export const AssetUploadSource = z.enum(assetUploadSources);
export type AssetUploadSource = z.infer<typeof AssetUploadSource>;
